var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNightlife(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_15660)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1088 26.1863C33.1088 28.0023 30.3555 28.0023 30.3555 26.1863V1.34739C30.3555 0.585823 30.9999 0 31.7029 0H40.2559C41.0174 0 41.6033 0.585823 41.6033 1.34739V26.1863C41.6033 28.0023 38.7913 24.3702 38.9085 26.1863L39.2014 32.9233L35.1006 30.5214L33.1088 26.1863Z",
    fill: "url(#paint0_linear_331_15660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9885 38.6067C47.9885 40.3642 46.2896 37.0835 45.2937 38.6067L40.5485 45.3437C39.0254 47.5112 41.4273 41.3015 38.7911 41.3015C37.1507 37.2007 36.5649 45.5194 33.6358 38.7239C32.5813 36.2634 33.9287 44.5821 31.8783 42.8832L26.7231 38.6067C25.3171 37.435 23.9697 40.3642 23.9697 38.6067V32.3384C23.9697 28.1205 27.3089 24.8398 31.7026 24.8398H40.2556H40.4899C44.6493 24.8398 47.9885 28.179 47.9885 32.3384V38.6067Z",
    fill: "url(#paint1_linear_331_15660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7155 3.56978C69.8995 10.4239 71.8327 17.7467 76.9294 22.8434C81.9674 27.8814 89.2902 29.8147 96.1443 27.9986C97.1402 27.7057 98.0776 28.643 97.8432 29.6389C93.3324 46.3349 72.3013 52.1931 59.9405 39.8322C47.4625 27.4128 53.4378 6.38173 70.0752 1.92947C71.0711 1.63656 72.0084 2.57388 71.7155 3.56978Z",
    fill: "url(#paint2_linear_331_15660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1603 9.25715L90.8715 13.768L92.1603 18.2788C92.4532 19.2747 91.5159 20.2706 90.4615 19.9191L85.9506 18.6303L81.4984 19.9191C80.4439 20.2706 79.5066 19.2747 79.7995 18.2788L81.0883 13.768L79.7995 9.25715C79.5066 8.20267 80.4439 7.26535 81.4984 7.55826L85.9506 8.90565L90.4615 7.55826C91.5159 7.26535 92.4532 8.20267 92.1603 9.25715Z",
    fill: "url(#paint3_linear_331_15660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6792 64.5607L90.5784 66.8454L88.3523 70.9461C87.8251 71.8834 86.4777 71.8834 85.9504 70.9461L83.7243 66.8454L79.565 64.5607C78.6277 64.092 78.6277 62.686 79.6236 62.2174L83.7243 59.9327L85.9504 55.8319C86.4777 54.8946 87.8251 54.8946 88.3523 55.8319L90.5784 59.9327L94.7378 62.2174C95.6751 62.7446 95.6751 64.092 94.6792 64.5607Z",
    fill: "url(#paint4_linear_331_15660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6792 92.9083L90.5784 95.1344L88.3523 99.2352C87.8251 100.231 86.4777 100.231 85.9504 99.2352L83.7243 95.1344L79.565 92.9083C78.6277 92.3811 78.6277 91.0337 79.6236 90.5064L83.7243 88.2803L85.9504 84.121C86.4777 83.1836 87.8251 83.1836 88.3523 84.121L90.5784 88.2803L94.7378 90.5064C95.6751 91.0337 95.6751 92.3811 94.6792 92.9083Z",
    fill: "url(#paint5_linear_331_15660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.522 9.49033L14.4212 11.7165L12.1951 15.8172C11.6679 16.7545 10.3205 16.7545 9.79322 15.8172L7.56709 11.7165L3.40775 9.49033C2.47043 8.96309 2.47043 7.6157 3.46633 7.08846L7.56709 4.80375L9.79322 0.702988C10.3205 -0.234329 11.6679 -0.234329 12.1951 0.702988L14.4212 4.80375L18.5806 7.08846C19.5179 7.6157 19.5179 8.96309 18.522 9.49033Z",
    fill: "url(#paint6_linear_331_15660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.936 33.6863L13.8353 35.9124L11.6092 40.0718C11.0819 41.0091 9.73452 41.0091 9.20728 40.0132L6.98115 35.9124L2.82181 33.6863C1.88449 33.1591 1.88449 31.8117 2.88039 31.2844L6.98115 29.0583L9.20728 24.899C9.73452 23.9616 11.0819 23.9616 11.6092 24.9575L13.8353 29.0583L17.9946 31.2844C18.9319 31.8117 18.9319 33.1591 17.936 33.6863Z",
    fill: "url(#paint7_linear_331_15660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8252 44.8146C71.479 57.4097 71.479 77.9136 58.8252 90.5088C46.23 103.104 25.7847 103.104 13.131 90.5088C0.535771 77.9136 0.535771 57.4097 13.131 44.8146C25.7847 32.1608 46.23 32.1608 58.8252 44.8146Z",
    fill: "url(#paint8_linear_331_15660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7537 67.6587C47.7537 59.2815 46.3477 51.7243 44.063 46.2762C39.3764 35.3213 32.5808 35.3213 27.9528 46.2762C22.9733 58.0512 22.9733 77.2662 27.9528 88.9827C32.5808 99.9962 39.3764 99.9962 44.063 88.9827C46.3477 83.5931 47.7537 76.036 47.7537 67.6587ZM46.5234 45.2217C51.8544 57.6412 51.8544 77.6177 46.5234 90.0958C40.9581 103.277 31.0577 103.277 25.4338 90.0958C20.1614 77.6177 20.1614 57.6412 25.4338 45.2217C31.0577 32.0407 40.9581 32.0407 46.5234 45.2217Z",
    fill: "url(#paint9_linear_331_15660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5641 67.6602C65.5641 64.614 62.4592 61.7434 57.3626 59.6345C45.5875 54.5964 26.3725 54.5964 14.6561 59.6345C3.70116 64.2625 3.70116 71.058 14.6561 75.686C26.3725 80.6655 45.5875 80.6655 57.3626 75.686C62.4592 73.5185 65.5641 70.7065 65.5641 67.6602ZM58.417 57.1154C71.5981 62.7393 71.5981 72.5812 58.417 78.2051C45.9976 83.4775 26.021 83.4775 13.543 78.2051C0.361971 72.5812 0.361971 62.7393 13.543 57.1154C26.021 51.7844 45.9976 51.7844 58.417 57.1154Z",
    fill: "url(#paint10_linear_331_15660)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_331_15660",
    x1: 30.3614,
    y1: 16.4752,
    x2: 41.6042,
    y2: 16.4752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03001C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D5976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_331_15660",
    x1: 23.9787,
    y1: 35.3256,
    x2: 47.9862,
    y2: 35.3256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8001B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541176,
    stopColor: "#DB1648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_331_15660",
    x1: 53.2683,
    y1: 24.1698,
    x2: 97.852,
    y2: 24.1698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521569,
    stopColor: "#33D7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_331_15660",
    x1: 79.7262,
    y1: 13.7629,
    x2: 92.1908,
    y2: 13.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D28B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE52D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_331_15660",
    x1: 78.852,
    y1: 63.3791,
    x2: 95.408,
    y2: 63.3791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D28B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470588,
    stopColor: "#E8B816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE52D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_331_15660",
    x1: 78.852,
    y1: 91.6763,
    x2: 95.408,
    y2: 91.6763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D28B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470588,
    stopColor: "#E8B816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE52D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_331_15660",
    x1: 2.73264,
    y1: 8.27762,
    x2: 19.2884,
    y2: 8.27762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D28B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470588,
    stopColor: "#E8B816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE52D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_331_15660",
    x1: 2.14881,
    y1: 32.4916,
    x2: 18.7029,
    y2: 32.4916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D28B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458824,
    stopColor: "#E8B816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE52D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_331_15660",
    x1: 3.70496,
    y1: 67.6283,
    x2: 68.3032,
    y2: 67.6283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490196,
    stopColor: "#33D7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_331_15660",
    x1: 21.4896,
    y1: 67.647,
    x2: 50.5179,
    y2: 67.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65C0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_331_15660",
    x1: 3.67697,
    y1: 67.6269,
    x2: 68.2899,
    y2: 67.6269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65C0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490196,
    stopColor: "#92DFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFFFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_15660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightlife);
export default __webpack_public_path__ + "static/media/nightlife.ebde4d2492bb16cf553caba96b7a941e.svg";
export { ForwardRef as ReactComponent };